import { render } from "./readjustmentLotComponent.vue?vue&type=template&id=1917cb82"
import script from "./readjustmentLotComponent.vue?vue&type=script&lang=js"
export * from "./readjustmentLotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__